module.exports = __webpack_public_path__ + "assets/b61.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b61.png
// module id = 651
// module chunks = 0